import classNames from "classnames";
import type React from "react";
import type { ReactElement } from "react";
import "./TitleValuePairs.css";
import { Flex, type Gap } from "../Common/Flex";
import Label from "../Common/Label";
import Tag from "../Common/Tag";

type TitleValuePairProps = {
    title: string | React.ReactNode;
    value: React.ReactNode;
    valueGap?: Gap;
};

export function TitleValuePairs({
    className,
    children,
}: {
    className?: string;
    children:
        | ReactElement<TitleValuePairProps>
        | (ReactElement<TitleValuePairProps> | undefined | false | string)[]
        | undefined;
}) {
    return children ? (
        <Flex.Column
            gap="medium"
            className={classNames("title-value-pairs", className)}
        >
            {children}
        </Flex.Column>
    ) : null;
}

export function TitleValuePair({ title, value, valueGap }: TitleValuePairProps) {
    return (
        <Flex.Row gap="small" alignItems="start" className="title-value-pair">
            <Label.XSmall.Light.N50 className="title-value-pair__title">
                {title}
            </Label.XSmall.Light.N50>
            <Flex.Row gap={valueGap} className="title-value-pair__value">
                {value}
            </Flex.Row>
        </Flex.Row>
    );
}

type TitleValuePairTagsProps = {
    label: string;
    tags: string[] | undefined;
};

export function TitleValuePairTags(props: TitleValuePairTagsProps) {
    const { label, tags } = props;
    return tags && tags.length !== 0 ? (
        <TitleValuePair
            title={label}
            valueGap="xsmall"
            value={tags.map((it) => <Tag.XXSmall.N80 key={it}>{it}</Tag.XXSmall.N80>)}
        />
    ) : null;
}
